import SecureLS from "secure-ls";

let ls = new SecureLS({ encodingType: "aes" });



const compareJwtToken = (token: string) => {
  if (typeof token !== "string" || !token)
    throw new Error("Invalid token provided");

  let isJwtExpired = false;
  const data: any = []; //jwt_decode(token);
  const currentTime = new Date().getTime() / 1000;

  if (currentTime > data.exp) isJwtExpired = true;

  return isJwtExpired;
};

export const storeToStorage = (key: string, value: any) => {
  ls.set(key, value);
};

export const getStoreStorage = (key: string) => {
  return ls.get(key);
};

export const clearStorage = () => ls.clear();
